export * from "./Mitochondria";
export * from "./EndoplasmicReticulum";
export * from "./GolgiApparatus";
export * from "./Centrosomes";
export * from "./Cytoplasm";
export * from "./Lysosomes";
export * from "./NuclearMembrane";
export * from "./Ribosomes";

export const organellesItems = {
  Centrosoma: {
    path: "/celulas/organelos-celulares/centrosoma",
  },
  Citoplasma: {
    path: "/celulas/organelos-celulares/citoplasma",
  },
  "Retículo endoplasmático": {
    path: "/celulas/organelos-celulares/reticulo-endoplasmatico",
  },
  "Aparato de Golgi": {
    path: "/celulas/organelos-celulares/aparato-golgi",
  },
  Lisosomas: {
    path: "/celulas/organelos-celulares/lisosomas",
  },
  Mitocondria: {
    path: "/celulas/organelos-celulares/mitocondria",
  },
  "Membrana nuclear": {
    path: "/celulas/organelos-celulares/membrana-nuclear",
  },
  Ribosomas: {
    path: "/celulas/organelos-celulares/ribosomas",
  },
};
